import { gql } from 'apollo-boost';

export const MODIFY_CUSTOMER = gql`
  mutation doModifyCustomer($id: ID!, $data: CustomerInput!) {
    modifyCustomer(id: $id, data: $data) {
      id
      region
      firstName
      lastName
      email
      matchAddress
      billingAddress {
        active
        phone
        country
        postalCode
        state
        city
        line2
        line1
        company
        lastName
        firstName
        id
      }
      shippingAddress {
        active
        phone
        postalCode
        country
        state
        city
        line2
        line1
        company
        lastName
        firstName
        id
      }
      activePrescription {
        id
        status
        expires
        doctorAuth {
          id
          status
          reviewAt
          doctorId
          doctorParty {
            firstName
            lastName
            company
            phone
          }
        }
        leftEye {
          power
          eyeType
        }
        rightEye {
          power
          eyeType
        }
      }
      defaultPaymentMethod {
        id
        active
        gateway
        brand
        last4
        expiryMonth
        expiryYear
      }
      customerSubscriptions {
        id
        status
        renewalActive
        renewalStatus
        renewalRegion
        nextRenewal
        lastRenewal
        frequency
        preferredDay
        preferredDate
        resumeDate
        plan {
          id
          planFamily {
            title
            handle
            id
          }
          title
          handle
          frequencies {
            frequency {
              frequency
            }
          }
          pauseOptions {
            pauseOption {
              value
            }
          }
          locales {
            quantity
            region
            quantity
            actualPrice
            basePrice
          }
        }
        renewalOrder {
          id
          grandTotalPrice
          creditDeduction
          discountDeduction
          taxPrice
          subtotalPrice
          shippingOption {
            shippingPrice
          }
          discounts {
            discountValue
            discountCode
          }
          productVariants {
            id
            productVariantId
            quantity
            linePrice
            productVariant {
              title
              handle
              attributes {
                attribute {
                  handle
                  value
                  property {
                    title
                  }
                }
              }
            }
          }
        }
        pausedDate
        reactivatedDate
        productVariants {
          quantity
          productVariant {
            handle
          }
        }
      }
    }
  }
`;
